import { useState, useEffect } from 'react';

interface MaintenanceStatus {
  isMaintenanceMode: boolean;
  maintenanceMessage: string;
  loading: boolean;
}

export const useMaintenanceStatus = (): MaintenanceStatus => {
  const [status, setStatus] = useState<MaintenanceStatus>({
    isMaintenanceMode: false,
    maintenanceMessage: 'Site en maintenance. Nous revenons bientôt !',
    loading: true
  });

  useEffect(() => {
    const checkMaintenanceStatus = async () => {
      try {
        // Appel à l'API pour récupérer les paramètres publics
        const response = await fetch('/api/settings/public');

        if (response.ok) {
          const settings = await response.json();

          const maintenanceMode = settings.maintenanceMode?.value || false;
          const maintenanceMessage = settings.maintenanceMessage?.value || 'Site en maintenance. Nous revenons bientôt !';

          setStatus({
            isMaintenanceMode: maintenanceMode,
            maintenanceMessage: maintenanceMessage,
            loading: false
          });
        } else {
          // En cas d'erreur API, ne pas activer le mode maintenance
          setStatus({
            isMaintenanceMode: false,
            maintenanceMessage: 'Site en maintenance. Nous revenons bientôt !',
            loading: false
          });
        }
      } catch (error) {
        console.error('Erreur lors de la vérification du statut de maintenance:', error);
        // En cas d'erreur, ne pas activer le mode maintenance pour éviter de bloquer le site
        setStatus({
          isMaintenanceMode: false,
          maintenanceMessage: 'Site en maintenance. Nous revenons bientôt !',
          loading: false
        });
      }
    };

    checkMaintenanceStatus();
  }, []);

  return status;
};